<template>
  <Card v-if="items.length > 0" :title="title" :title-level="1" margin="mt-3">
    <template #actions>
      <Badge :text="`${items.length} ${labelPlural}`" :variant="type === 'inspections' ? 'info' : 'primary'" pill />
    </template>
    <div class="list-group">
      <div
          v-for="item in items"
          :key="item.subblock_id"
          @click="handleItemClick(item.subblock_id)"
          class="list-group-item d-flex justify-content-between cursor-pointer"
          :class="{ 'list-group-item-action': clickable }"
      >
        <span>{{ item.name }}</span>
        <span>{{ item.physicalName }}</span>
        <!-- eslint-disable-next-line @intlify/vue-i18n/no-raw-text -->
        <span class="small text-muted">(Id: {{ item.subblock_id }})</span>
      </div>
    </div>
  </Card>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { Card, Badge } from "@/components/atomic";

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  items: {
    type: Array,
    default: () => []
  },
  type: {
    type: String,
    default: 'rooms',
    validator: (value) => ['rooms', 'inspections'].includes(value)
  },
  clickable: {
    type: Boolean,
    default: true
  },
  customClickHandler: {
    type: Function,
    default: null
  }
})

const router = useRouter()

const labelPlural = computed(() => {
  return props.type === 'inspections' ? 'Inspections' : 'Rooms'
})

const handleItemClick = (subblockId) => {
  if (!props.clickable) return

  if (props.customClickHandler) {
    props.customClickHandler(subblockId)
  } else {
    router.push(`/accommodation/${subblockId}`)
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.list-group-item-action:hover {
  background-color: var(--bs-gray-100);
}
</style>